import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SiteChrome from "@/components/SiteChrome";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import InvoiceRequestModal from "./components/InvoiceRequestModal";

/**
 * PedirFatura — public landing page opened from the "Pedir Fatura" button
 * embedded in the credentials email. It fetches the public inscription
 * summary (school + email) and pops up the InvoiceRequestModal so the
 * school can send the invoice request in one click from their inbox.
 */
export default function PedirFatura() {
  const { id } = useParams();
  const { lang } = useI18n();
  const [defaults, setDefaults] = useState(null);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!id) return;
    // Public summary endpoint — non-sensitive: only school + email.
    api.get(`/inscriptions/${id}/public`).then((r) => {
      setDefaults({ school: r.data.school || "", email: r.data.email || "" });
    }).catch(() => setError("Inscrição não encontrada"));
  }, [id]);

  const HEAD = {
    pt: { title: "Pedir fatura", back: "Voltar ao início", missing: "Inscrição não encontrada" },
    en: { title: "Request invoice", back: "Back to home", missing: "Enrolment not found" },
    es: { title: "Solicitar factura", back: "Volver al inicio", missing: "Inscripción no encontrada" },
  }[lang] || {
    title: "Pedir fatura", back: "Voltar ao início", missing: "Inscrição não encontrada",
  };

  return (
    <SiteChrome>
      <div className="max-w-lg mx-auto px-6 py-12 text-center">
        <h1 className="text-3xl font-[Fredoka] font-semibold text-white mb-2">{HEAD.title}</h1>
        {error && (
          <div className="mt-6 bg-white rounded-2xl border border-slate-200 p-6" data-testid="pedir-fatura-error">
            <p className="text-slate-700">{HEAD.missing}</p>
            <Button className="rounded-full mt-4" onClick={() => { window.location.href = "/"; }}>
              {HEAD.back}
            </Button>
          </div>
        )}
        {!error && !open && (
          <div className="mt-6 bg-white rounded-2xl border border-slate-200 p-6">
            <Button className="rounded-full" onClick={() => setOpen(true)}>{HEAD.title}</Button>
            <Button variant="outline" className="rounded-full ml-2" onClick={() => { window.location.href = "/"; }}>
              {HEAD.back}
            </Button>
          </div>
        )}
      </div>
      {open && defaults && (
        <InvoiceRequestModal
          inscriptionId={id}
          defaults={defaults}
          lang={lang}
          onClose={() => setOpen(false)}
        />
      )}
    </SiteChrome>
  );
}
